import { useQuery } from "@tanstack/react-query";
import { getCardLinks } from "@/services/DataService";

export const CARD_LINKS_KEY = ["card-links"] as const;

const cardLinksKey = (cardId: string) => [...CARD_LINKS_KEY, cardId] as const;

/**
 * The items a home page card links to: the report a routine run wrote, or the
 * outputs a content agent left for review.
 *
 * Read separately from the card itself, as a task's attachments are, so the
 * card list stays untouched and cheap. Read fresh on every open rather than
 * kept warm in the background: what a card holds changes as the agent works,
 * and the drawer is the only thing that shows it. Refetched after a tool turn
 * by `invalidateArtifactQueries`.
 */
export const useCardLinks = (cardId: string | null) => {
  return useQuery({
    queryKey: cardLinksKey(cardId ?? ""),
    queryFn: () => getCardLinks(cardId!),
    enabled: cardId !== null,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
